import React from 'react';
import { X, Award, ArrowRight } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface AnswerSplashProps {
  onClose: () => void;
}

const SplashContainer = styled.div`
  position: fixed;
  padding: var(--spacing-4);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export default function AnswerSplash({onClose} : AnswerSplashProps) {
     const navigate = useNavigate();
  const path = useLocation().pathname;
  const hotelId = path.split('/')[2];

  const handleGoToBoost = () => {
    onClose();
    navigate(`/upgrade?hotelId=${hotelId}`);
  };    
   return (
    <SplashContainer className="animate-fadeIn">
      {/* Backdrop with blur */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        style={{ zIndex: -1 }}
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl mx-auto overflow-hidden animate-slideUp">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full"
          aria-label="Close splash"
        >
          <X size={24} />
        </button>

        {/* Content Section */}
        <div className="px-8 py-10">
          {/* Icon */}
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--color-primary-600)' }}>
              <Award className="w-8 h-8 text-white" />
            </div>
          </div>

          {/* Main Message */}
          <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">
            What if your certification answered these questions for you?
          </h2>

          <p className="text-lg text-gray-700 mb-8 text-center leading-relaxed">
            It can - Boost now to pre-populate responses for up to 40% of the questions based on your certification
          </p>

          {/* CTA Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleGoToBoost}
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 text-white font-semibold rounded-lg transition-all shadow-md hover:shadow-lg"
              style={{ backgroundColor: 'var(--color-primary-600)' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--color-primary-700)'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--color-primary-600)'}
            >
              Boost now
              <ArrowRight size={18} />
            </button>

            <button
              onClick={onClose}
              className="w-full px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all"
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </SplashContainer>
  );
}